module.exports = __webpack_public_path__ + "static/media/imgEmojiHand@3x.cb8007b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgEmojiHand@3x.png
// module id = 365
// module chunks = 22